import SiteLayout from '@/layouts/site/SiteLayout.vue'

export default [
  {
    path: '/',
    component: SiteLayout,
    children: [
      {
        path: 'privacy-policy',
        name: 'privacy-policy',
        meta: {
          title: 'Privacy Policy',
        },
        component: () => import('@/views/site/PrivacyPolicyPage.vue'),
      },
      {
        path: 'cookie-policy',
        name: 'cookie-policy',
        meta: {
          title: 'Cookie Policy',
        },
        component: () => import('@/views/site/CookiePolicyPage.vue'),
      },
    ],
  },
]
